<template>
    <b-card class="card-mini" no-body>
      <div class="left">
          <div class="title">
              <h4>
                <PuSkeleton :loading="isLoading" :count="1" width='40px'>                
                  {{resultOne}}
                </PuSkeleton>
              </h4>
                <div class="result"  :class="{negative : isNegative}">
                  <PuSkeleton :loading="isLoading" width="20px">
                    {{difference}}
                  </PuSkeleton>      
                </div>    
            </div>

            <PuSkeleton :loading="isLoading" :count="1" height="30px">
              <div class="line">
                <b-progress height="1.75rem" :value="value" :max="max" class="positive" :class="{negative : isNegative}">
                </b-progress>
                <div class="date">
                  {{date}}
                </div>
              </div>
            </PuSkeleton>

            <h4 class="secondTitle">
              <PuSkeleton :loading="isLoading" :count="1" width='40px'>
                {{resultTwo}}
              </PuSkeleton>
            </h4>
            
            <PuSkeleton :loading="isLoading" :count="1" height="30px">
              <div class="line grey">
                <b-progress height="1.75rem" :value="valueTwo" :max="max">
                </b-progress>                        
                <div class="date">
                  {{dateTwo}}
                </div>
              </div>
            </PuSkeleton>
          </div>
    </b-card>
</template>


<script>
import card from '../card/Card'
//
export default {
  name: "CardMini",
  components:{ 
  },
  mixins: [card],
  props:{   
    resultOne:{
      type:String,
      default:'0',
    },
    resultTwo:{
      type:String,
      default:'0',
    },
    date:{
      type:String,
      default:'20 décembre 2020',
    },
    dateTwo:{
      type:String,
      default:'20 décembre 2020',
    },
  },
  data(){
    return {
        valueTwo: 0, 
        isNegative : false,
        isLoading:true,
    }
  },
  methods : {
 
  },  
  mounted (){
    this.getPourcentBetween(this.resultOne, this.resultTwo);
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }   
}
</script>